module.exports = __webpack_public_path__ + "static/hda-0c12b6b1b4dba85ab798eccbc86fb798.svg";